import { ChevronLeft, ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components";
import PageHeader from "../../../../components/common/PageHeader";
import { residentReportDemoLoader } from "../data/residentReportDemo.data";
import { ResidentReportReader } from "../reader/ResidentReportReader";

export default function ResidentReportPage() {
  const navigate = useNavigate();

  return (
    <main className="min-h-full bg-[#effbf3] px-4 py-6 text-[#004b3a] sm:px-6 lg:px-8">
      <div className="mx-auto max-w-[1440px] space-y-6">
        <PageHeader
          title="Resident Engagement Report"
          subtitle={
            <span>
              <span className="font-bold uppercase tracking-[0.12em] text-[#008a72]">Resident detail</span>
              <br />
              Individual resident engagement, attendance, and participation details.
            </span>
          }
          actions={
            <div className="flex flex-wrap items-center gap-2">
              <Button type="button" variant="ghost" onClick={() => navigate("/reports")}>
                <ChevronLeft />
                Reports
              </Button>
              <Button type="button" variant="brand-outline" onClick={() => window.print()}>
                <ExternalLink />
                Export report
              </Button>
            </div>
          }
        />
        <ResidentReportReader
          loadBatch={residentReportDemoLoader}
          resetKey="resident-report-demo"
        />
      </div>
    </main>
  );
}
